import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-110d1d0b")

_pushScopeId("data-v-110d1d0b")
const _hoisted_1 = { class: "title-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 2,
  class: "title-container"
}
const _hoisted_4 = { class: "left-container" }
const _hoisted_5 = { class: "right-container" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.text && !_ctx.img && _ctx.subObject == null)
        ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.text), 1))
        : (_ctx.img && !_ctx.text && _ctx.subObject == null)
          ? (_openBlock(), _createBlock("img", {
              key: 1,
              class: `img-${_ctx.imgWidthType}`,
              src: _ctx.img
            }, null, 10, ["src"]))
          : _createCommentVNode("", true),
      (_ctx.subObject != null && _ctx.text && !_ctx.img)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(_ctx.text), 1)
            ]),
            _createVNode("div", _hoisted_5, [
              (_ctx.subObject.subTitle)
                ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.subObject.subTitle), 1))
                : _createCommentVNode("", true),
              (_ctx.subObject.desc)
                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.subObject.desc), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})